<template>
  <div class="product">
    <router-link to="/">返回首頁</router-link>
    <!-- <div class="xxx" @click="xxx()">xxxxxxxxxxx</div>
    <div>{{res}}</div> -->
  </div>
</template>

<script>
import axios from 'axios';
import $ from 'jquery';

export default {
  name: 'product',
  props: {
  },
  data() {
    return {
      res: 'adxxxxxdafafafaa'
    }
  },
  methods:{
    xxx(){
      this.res = this.res.substr(0, 2);
    }
  },
  components:{

  },
  computed:{

  },
  mounted(){
    //  axios.get('/tyg/app/index.php?i=1&c=site&a=site&do=get_article&id=20', {
    //     params:{
          
    //     }
    //   }).then((res) => {
    //     console.log(res.data);
    //   })
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .xxx {
    color: black;
  }

  @media screen and (max-width:900px){
  .xxx {
    color: red;
    }
  }

</style>
